export default __webpack_public_path__ + "static/media/A15B845A-B45D-4A88-931B-F6C18FFF34CC_1_105_c.0aa80262.jpeg";